var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcFaceFrowningGrey = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "luminosity"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 10C20 15.5228 15.5228 20 10 20C4.47778 20 0 15.5228 0 10C0 4.47778 4.47778 0 10 0C15.5228 0 20 4.47778 20 10Z",
    fill: "#CDCDCD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.38889 10.0002C7.15595 10.0002 7.77778 9.12966 7.77778 8.05577C7.77778 6.98189 7.15595 6.11133 6.38889 6.11133C5.62183 6.11133 5 6.98189 5 8.05577C5 9.12966 5.62183 10.0002 6.38889 10.0002Z",
    fill: "#664500"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6111 10.0002C14.3781 10.0002 14.9999 9.12966 14.9999 8.05577C14.9999 6.98189 14.3781 6.11133 13.6111 6.11133C12.844 6.11133 12.2222 6.98189 12.2222 8.05577C12.2222 9.12966 12.844 10.0002 13.6111 10.0002Z",
    fill: "#664500"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.81379 15.4843C4.91268 15.5738 5.06045 15.5793 5.16656 15.5004C5.18823 15.4843 7.34545 13.8893 9.9999 13.8893C12.6477 13.8893 14.8121 15.4843 14.8332 15.5004C14.9393 15.5793 15.0871 15.5727 15.186 15.4843C15.2843 15.3954 15.3066 15.2488 15.2382 15.1354C15.1666 15.0165 13.451 12.2227 9.9999 12.2227C6.54879 12.2227 4.83268 15.016 4.76156 15.1354C4.69323 15.2493 4.7149 15.3954 4.81379 15.4843Z",
    fill: "#664500"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcFaceFrowningGrey);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ic-face-frowning-grey.ab344989001f1bd9f097f4007d2097cd.svg";